import './styled.css';
import Banner from '../../assets/images/banner.webp';

export default function Header() {
  return (
    <div className='d-flex justify-content-center mb-5'>
      <img
        alt='Banner do evento'
        src={"https://s3.amazonaws.com/bucket.app.eventos/gallery/da604eb2-ce6b-414c-9db4-c080664e6bc4/2025/dc114f1c-3690-41ae-9051-f6c423d620c8.webp?AWSAccessKeyId=AKIAJ2EWX2HWZM4NBALA&Expires=2141185578&Signature=FjmN6oqOy%2FgIGagJCIntnbET38I%3D"}
        className='header-img'
      />
    </div>
  );
}
export function BannerLogin() {
  return (
    <div className='d-flex justify-content-center mb-5 mt-5'>
      <img
        alt='Banner do evento'
        src={"https://s3.amazonaws.com/bucket.app.eventos/gallery/da604eb2-ce6b-414c-9db4-c080664e6bc4/2025/dc114f1c-3690-41ae-9051-f6c423d620c8.webp?AWSAccessKeyId=AKIAJ2EWX2HWZM4NBALA&Expires=2141185578&Signature=FjmN6oqOy%2FgIGagJCIntnbET38I%3D"}
        className='header-img'
      />
    </div>
  );
}
